import SwStatusInfo from './sw-status-info.vue';

export { SwStatusInfo };
